'use strict';

module.exports = function parseAlgoliaClientVersion(agent) {
  var parsed = // User agent for algoliasearch >= 3.33.0
  agent.match(/Algolia for JavaScript \((\d+\.)(\d+\.)(\d+)\)/) || // User agent for algoliasearch < 3.33.0
  agent.match(/Algolia for vanilla JavaScript (\d+\.)(\d+\.)(\d+)/);

  if (parsed) {
    return [parsed[1], parsed[2], parsed[3]];
  }

  return undefined;
};